import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState, useEffect, useRef } from 'react';
import { useObservable } from '../../../../hooks/rxjs';
import { map, filter } from 'rxjs/operators';
import { useRoomSession } from '../../../../context/room_session';
import { GpsId } from '@streem/domain-id';
import { styled } from '@streem/ui-react';
import { Request } from './request';
import { LocationBlocked } from './location_blocked';
import { WallItem } from 'streem-sdk-protobuf';
export function GpsResponse() {
    const [open, setOpen] = useState(false);
    const [rejected, setRejected] = useState(false);
    const gpsIdsToIgnore = useRef([]);
    const [awaitingResponse, setAwaitingResponse] = useState(false);
    const roomSession = useRoomSession();
    const [remoteUser] = useObservable(roomSession.user.remoteUser);
    // TODO: fix eslint error be wrapping in useMemo: https://streempro.atlassian.net/browse/ST-3779
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const gpsId = new GpsId();
    const [gpsRequest] = useObservable(roomSession.geolocation.requests.pipe(map(requests => requests[requests.length - 1])));
    const [gpsResponse] = useObservable(roomSession.geolocation.responses.pipe(map(responses => responses[responses.length - 1]), filter(response => !gpsIdsToIgnore.current.includes(response?.inResponseToWallItemId ?? ''))));
    const latestResponseStatus = gpsResponse?.status;
    const responseStatusRef = useRef(latestResponseStatus);
    const latestResponseId = gpsResponse?.inResponseToWallItemId;
    const responseIdRef = useRef(latestResponseId);
    const latestRequestId = gpsRequest?.artifactId;
    const requestIdRef = useRef(latestRequestId);
    useEffect(() => {
        if (responseIdRef.current !== latestResponseId) {
            responseStatusRef.current = latestResponseStatus;
            responseIdRef.current = latestResponseId;
            setAwaitingResponse(false);
        }
        if (!awaitingResponse) {
            const rejected = responseStatusRef.current === WallItem.Artifact.Status.REJECTED;
            setOpen(rejected);
            setRejected(rejected);
        }
    }, [latestResponseStatus, latestResponseId, awaitingResponse]);
    useEffect(() => {
        if (requestIdRef.current !== latestRequestId) {
            requestIdRef.current = latestRequestId;
            if (typeof latestRequestId !== 'undefined') {
                setOpen(true);
            }
        }
    }, [latestRequestId]);
    const fulfill = useCallback(() => {
        if (latestRequestId) {
            roomSession.geolocation.fulfillGeolocation(gpsId, latestRequestId);
            setOpen(false);
        }
    }, [latestRequestId, gpsId, roomSession.geolocation]);
    const dismiss = () => {
        setAwaitingResponse(false);
        setOpen(false);
        setRejected(false);
    };
    const reject = useCallback(() => {
        if (latestRequestId) {
            gpsIdsToIgnore.current.push(latestRequestId);
            roomSession.geolocation.rejectGeolocation(gpsId, latestRequestId);
            setOpen(false);
        }
    }, [latestRequestId, gpsId, roomSession.geolocation]);
    return (_jsx(_Fragment, { children: open && (_jsxs(PopoutContainer, { children: [rejected && _jsx(LocationBlocked, { dismiss: dismiss }), !rejected && (_jsx(Request, { fulfill: fulfill, reject: reject, remoteUserName: remoteUser?.name }))] })) }));
}
const PopoutContainer = styled.div `
    z-index: ${({ theme }) => theme.layers.modal};
    height: 100%;
    align-items: center;
    margin: 0 auto;
    padding: 2.5vw;
    display: flex;
`;
//# sourceMappingURL=gps_response.js.map